module.exports = __webpack_public_path__ + "static/media/Rubik-Medium.e785acbf.ttf";